<div class="d-flex">
  <h1 class="page-title me-auto">Review Employee Requests</h1>
</div>
<ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="active">
  <li [ngbNavItem]="1">
    <a ngbNavLink class="tab-title">Pending</a>
    <ng-template ngbNavContent>
      <lib-pending-request-tab></lib-pending-request-tab>
    </ng-template>
  </li>
  <li [ngbNavItem]="2">
    <a ngbNavLink class="tab-title">Historical</a>
    <ng-template ngbNavContent>
      <lib-historical-request-tab></lib-historical-request-tab>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
